import Dexie from 'dexie';

const sharedDb = new Dexie('SharedPlantTracker');

sharedDb.version(1).stores({
  plantSpecies: 'id, commonName, scientificName',
  syncConfig: 'id',
  pendingChanges: '++seq, table, recordId, operation, timestamp',
});

// Version 2: Add indexes for erosion/stabilization fields
sharedDb.version(2).stores({
  plantSpecies: 'id, commonName, scientificName, rootType, floodTolerance, *applications',
  syncConfig: 'id',
  pendingChanges: '++seq, table, recordId, operation, timestamp',
});

export default sharedDb;
